import React from 'react';
import { Form } from 'react-final-form';

import { MDText } from 'i18n-react';

import { VALUATIONS_GA_TAGS } from 'Utilities/analytics';
import { stringNumberToInt } from 'Utilities/formatter';

import ConfirmModal from '../../../../components/ConfirmModal/ConfirmModal';
import Texts from '../../../../texts.json';

import { MileageInput } from './MileageInput';

import styles from './MileageInput.scss';

const LocalT = new MDText(Texts);

interface MileageInputHighProps {
  confirmMileage: {
    onConfirm: ((value: { mileage: number }) => Promise<void>);
    onReject: () => void | Promise<void>;
  };
  isCarValueTracker?: boolean;
  mileage: number;
  modalClassName?: string;
}

const MileageInputHigh = ({
  confirmMileage,
  isCarValueTracker,
  mileage,
  modalClassName,
}: MileageInputHighProps) => (
  <Form
    initialValues={{
      mileage: stringNumberToInt(mileage) || '', // When adding back `,` numbers add `toLocaleString`
    }}
    onSubmit={({ mileage: newMileage }) => {
      confirmMileage.onConfirm({ mileage: stringNumberToInt(newMileage) });
    }}
    render={({ handleSubmit, ...state }) => (
      <ConfirmModal
        {...{ modalClassName }}
        onConfirm={ () => {
          if (!isCarValueTracker) {
            VALUATIONS_GA_TAGS.CONFIRM_MILEAGE_MODAL_SUBMIT({
              mileage: state?.values?.mileage,
            });
          }
          handleSubmit();
        }}
        onReject={confirmMileage.onReject}
      >
        <div>
          <h2>{LocalT.translate('components.mileageField.warnings.tooHigh.title')}</h2>
          <p>{LocalT.translate('components.mileageField.warnings.tooHigh.detail')}</p>
        </div>
        <form
          noValidate
          className={styles.highMileageForm}
          onSubmit={handleSubmit}
        >
          <MileageInput
            isHighMileageModal
            noLabel
            validateOnInit
            {...{ isCarValueTracker, mileage }}
          />
        </form>
      </ConfirmModal>
    )}
  />
);

export default MileageInputHigh;
